import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function SuperAdminRoute({ children }) {
  const [isSuperAdmin, setIsSuperAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function checkSuperAdmin() {
      console.log('[SuperAdmin] Starting super admin check...');

      try {
        // Get the current session directly from supabase
        const { data: { session }, error: sessionError } = await supabase.auth.getSession();

        if (sessionError || !session) {
          console.log('[SuperAdmin] No session found, redirecting to dashboard');
          setIsSuperAdmin(false);
          setLoading(false);
          return;
        }

        console.log('[SuperAdmin] Session found for user:', session.user.id, session.user.email);

        // Check if user is in super_admins table using the RPC function
        const { data: isSuperAdmin, error } = await supabase
          .rpc('is_super_admin');

        console.log('[SuperAdmin] RPC result:', { isSuperAdmin, error });

        if (error) {
          console.error('[SuperAdmin] Error checking super admin status:', error);
          setIsSuperAdmin(false);
        } else {
          console.log('[SuperAdmin] Is super admin:', isSuperAdmin);
          setIsSuperAdmin(isSuperAdmin === true);
        }
      } catch (err) {
        console.error('[SuperAdmin] Exception checking super admin status:', err);
        setIsSuperAdmin(false);
      } finally {
        setLoading(false);
      }
    }

    checkSuperAdmin();
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '16px',
        color: '#64748b'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #e2e8f0',
          borderTopColor: '#3b82f6',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite'
        }}></div>
        <p>Checking permissions...</p>
      </div>
    );
  }

  if (!isSuperAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
